var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"font-weight-bold mt-6 px-8"},[_vm._v(" Tågvändingar ")]),_c('TrafficMessageRow',{attrs:{"items":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }